import {Directive, HostBinding} from '@angular/core';

@Directive({
  selector: '[no-background]'
})
export class NoBackgroundDirective {
  @HostBinding('class')
  elementClass = 'no-background';
}
